<script>
  import Icon from "./icon.svelte";
  import Icons from "../data";
</script>

<section>
  <div class="map-container">
    <img
      class="background"
      src="https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FBackground.PNG?v=1618917341285"
    />
    <img
      class="background"
      src="https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FMap%20icons.PNG?v=1618917339533"
    />
    {#each Icons as icon}
      <Icon
        name={icon.name}
        y={icon.y}
        x={icon.x}
        url={icon.url}
        hover={icon.hover}
        on:pressed
      />
    {/each}
  </div>
</section>

<style>
  section {
    background-color: #1c8a93;
    height: 100%;
    width: 62.5%;
    border-left: 10px solid #b2dee5;
    border-right: 10px solid #b2dee5;
  }

  .map-container {
    width: 87%;
    height: 100%;
    margin: 0 auto;
    position: relative;
    border-right: 3px solid #000;
    border-left: 3px solid #000;
  }

  .background {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  @media only screen and (max-width: 1200px) {
    section {
      width: 100%;
    }
  }
</style>
